import { useState } from 'react';
import './App.css';
import Articles from './components/Articles';
import Keywords from './components/Keywords';
import Questions from './components/Questions';
import SummarizeInput from './components/SummarizeInput';
import Configuration from './components/Configuration';
import { useCustomEventListener } from 'react-custom-events';

function App() {
  const [dataChanged, setDataChanged] = useState<number>(0);
  function summaryFinished(): void {
    setDataChanged(dataChanged + 1);
  }

  useCustomEventListener('status',
    (data) => {
      console.log(`Status: ${data}`);
    }
  );

  return (
    <div className='main-container'>
      <SummarizeInput onFinished={summaryFinished} />
      <div className='title'><span className='text-accent font-semibold'>@note</span>: bookmarks evolved</div>
      <div className='subtitle'>Install as application for better experience. <a className='subtitle-link' href='/'>How to Install a PWA on iOS, Android, Windows & Mac [2024 Guide]</a></div>
      <div className="boxes-container">
        <Keywords dataChanged={dataChanged} />
        <Questions dataChanged={dataChanged} />
        <Articles dataChanged={dataChanged} />
      </div>
      <div className='footer'>© 2024 Tomasz Borycki</div>
      <Configuration />
    </div>
  );
}

export default App;
